// Pricing Calculator (Atrium item 10) — the single client transport for the live
// estimate. POSTs the stacked service payloads to the session-auth estimate
// endpoint (NOT /api/v1/*), reusing the shared CSRF helper. The server prices the
// stack through the SAME path Post-a-Project uses (PostingCalculator::Estimate),
// so the returned numbers match what the customer will be charged.

import { csrfToken } from "@/lib/orderActions"

// @param projects [Array] flat per-service pricing payloads (pricePayload shape)
// @param code [String|null] a single top-level promo code the server fans out
// @returns the estimate JSON, or null on any transport/validation failure (the
//   caller keeps the last good estimate and surfaces a soft error).
export async function fetchEstimate(projects, code, { signal } = {}) {
  try {
    const res = await fetch("/pricing-calculator/estimate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": csrfToken(),
      },
      body: JSON.stringify({ projects, code: code || undefined }),
      signal,
    })

    if (!res.ok) return null

    return await res.json()
  } catch {
    return null
  }
}
